import { OauthConfiguration, OauthAuthGuardRouteConfiguration } from '@westjetairlines/wjesd-oauth2-library';

export const oauthConfig: OauthConfiguration = {
  clientId : 'c3d33f03-b37c-4052-9f7a-0f1a8b7a6b90',
  tenantId : '',
  redirectUri : 'https://waiversandfavours.westjet.com/',
  resource : 'https://westjet.onmicrosoft.com/waiversandfavours-api.azurewebsites.net/',
  scope : 'openid',
  state : '',
  issuer : 'https://sts.windows.net/20d3ea97-10c0-4abd-b45c-cde0effc51c2/',
  tokenUrl : 'https://login.microsoftonline.com/20d3ea97-10c0-4abd-b45c-cde0effc51c2/oauth2/token',
  loginUrl : 'https://login.microsoftonline.com/20d3ea97-10c0-4abd-b45c-cde0effc51c2/oauth2/authorize',
  logoutUrl : 'https://login.microsoftonline.com/20d3ea97-10c0-4abd-b45c-cde0effc51c2/oauth2/logout',
  sessionRenewalCount: 10
};

let oAuthRouteConfig: OauthAuthGuardRouteConfiguration = {
  NoPermissionRedirectRoute : '/forbidden',
  SessionExpiredRedirectRoute: '/welcome'
};

export const environment = {
  production: false,
  envName: 'prd',
  oauthProperties : oauthConfig,
  apiEndpoint: 'https://waiversandfavours-api.azurewebsites.net/api/',
  oauthRoute: oAuthRouteConfig
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts